import {
  equipmentIdAtom,
  identifiersAtom,
} from '@/features/equipment-browser/equipment-details/state/selected-equipment.state';
import {
  drawerIsOpenAtom,
  drawerTypeAtom,
} from '@/features/equipment-browser/equipment-drawer-loader/state/drawer.state';
import { jotaiStore } from '@/providers/jotai/jotai-store';

export const clearEquipmentRouteState = (): void => {
  jotaiStore.set(identifiersAtom, {
    viewId: undefined,
    sectionId: undefined,
    equipmentId: undefined,
  });
  jotaiStore.set(equipmentIdAtom, undefined);
  jotaiStore.set(drawerIsOpenAtom, false);
  jotaiStore.set(drawerTypeAtom, undefined);
};
